import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../App';
import { useNavigate } from 'react-router-dom';
import { useSiteSettings } from '../hooks/useSiteSettings';

function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  // Logo/başlık/renk alan adına göre markadan gelir (bkz. server/utils/brands.js).
  const brand = useSiteSettings();
  // Logo yüklenemezse (dosya sunucuda yok vb.) kırık görsel yerine marka adı yazılır.
  const [logoFailed, setLogoFailed] = useState(false);
  useEffect(() => { setLogoFailed(false); }, [brand.site_logo_url]);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showBranchSelect, setShowBranchSelect] = useState(false);
  const [branches, setBranches] = useState([]);
  const [tempUser, setTempUser] = useState(null);

  useEffect(() => {
    const savedUser = localStorage.getItem('crm_user');
    if (savedUser) {
      navigate('/');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post('/api/auth/login', { email, password });
      const { user, branches: branchList } = response.data;
      
      if (branchList.length === 1) {
        login(user, response.data.token, branchList[0].industry);
        navigate('/');
      } else {
        setTempUser({ user, token: response.data.token });
        setBranches(branchList);
        setShowBranchSelect(true);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Giriş başarısız');
    } finally {
      setLoading(false);
    }
  };

  const handleBranchSelect = (branch) => {
    const userData = { ...tempUser.user, branch_id: branch.id, branch_name: branch.name, industry: branch.industry };
    login(userData, tempUser.token, branch.industry);
    navigate('/');
  };

  if (showBranchSelect) {
    return (
      <div className="login-page">
        <div className="login-decoration">
          <div className="decoration-circle circle-1"></div>
          <div className="decoration-circle circle-2"></div>
        </div>
        <div className="login-container">
          <div className="login-header">
            <h1 className="login-title">Şube Seçin</h1>
            <p className="login-subtitle">Hangi işletmede çalışmak istiyorsunuz?</p>
          </div>
          <div className="branch-list">
            {branches.map(branch => (
              <button key={branch.id} className="branch-item" onClick={() => handleBranchSelect(branch)}>
                <div className="branch-icon">
                  {branch.industry === 'dusakabin' ? (
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M4 12h16M4 12a2 2 0 00-2 2v4a2 2 0 002 2h16a2 2 0 002-2v-4a2 2 0 00-2-2M4 12V8a4 4 0 014-4h8a4 4 0 014 4v4M8 12v8m8-8v8" />
                    </svg>
                  ) : branch.industry === 'bridal_shop' ? (
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  ) : (
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                    </svg>
                  )}
                </div>
                <div className="branch-info">
                  <div className="branch-name">{branch.name}</div>
                  <div className="branch-industry" style={{textTransform:'capitalize'}}>
                    {branch.industry.replace('_', ' ')}
                  </div>
                </div>
              </button>
            ))}
          </div>
          <style>{``}</style>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-decoration">
        <div className="decoration-circle circle-1"></div>
        <div className="decoration-circle circle-2"></div>
        <div className="decoration-circle circle-3"></div>
      </div>
      
      <div className="login-container">
        <div className="login-header">
          <div className="login-logo">
            {brand.site_logo_url && !logoFailed ? (
              <img 
                src={brand.site_logo_url} 
                alt={brand.site_name || 'CRM'} 
                className="logo-img"
                onError={() => setLogoFailed(true)}
              />
            ) : (
              <span className="login-brand-name">{brand.site_name || 'CRM'}</span>
            )}
          </div>
          {brand.login_title && <h1 className="login-title">{brand.login_title}</h1>}
          <p className="login-subtitle">
            {brand.login_subtitle || 'İşletmenizi yönetmenin modern yolu'}
          </p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          {error && (
            <div className="login-error">
              <svg viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
              {error}
            </div>
          )}

          <div className="form-group">
            <label className="form-label">E-posta</label>
            <div className="input-wrapper">
              <svg className="input-icon" viewBox="0 0 20 20" fill="currentColor">
                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
              </svg>
              <input
                type="email"
                className="input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="E-posta adresinizi girin"
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Şifre</label>
            <div className="input-wrapper">
              <svg className="input-icon" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
              </svg>
              <input
                type="password"
                className="input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Şifrenizi girin"
                required
              />
            </div>
          </div>

          <button type="submit" className="btn btn-primary btn-lg w-full" disabled={loading}>
            {loading ? (
              <span className="loading-spinner"></span>
            ) : (
              'Giriş Yap'
            )}
          </button>
        </form>

        <div className="login-footer">
          <a href="/kayit-ol" className="register-link">Hesabınız yok mu? Kayıt Ol</a>
        </div>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700&display=swap');

        .login-page {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #030712;
          position: relative;
          overflow: hidden;
          font-family: 'Plus Jakarta Sans', sans-serif;
        }

        /* Ambient Background Glows */
        .login-decoration {
          position: absolute;
          inset: 0;
          overflow: hidden;
          pointer-events: none;
          z-index: 1;
        }

        .decoration-circle {
          position: absolute;
          border-radius: 50%;
          filter: blur(120px);
          opacity: 0.4;
        }

        .circle-1 {
          width: 500px;
          height: 500px;
          background: radial-gradient(circle, var(--login-accent) 0%, transparent 70%);
          top: -10%;
          right: -10%;
          animation: float 20s ease-in-out infinite;
        }

        .circle-2 {
          width: 600px;
          height: 600px;
          background: radial-gradient(circle, var(--login-glow-2) 0%, transparent 70%);
          bottom: -15%;
          left: -10%;
          animation: float 25s ease-in-out infinite reverse;
        }

        .circle-3 {
          width: 400px;
          height: 400px;
          background: radial-gradient(circle, var(--login-glow-3) 0%, transparent 70%);
          top: 40%;
          left: 35%;
          animation: glowPulse 10s ease-in-out infinite;
        }

        /* Subtle Grid Overlay */
        .login-page::before {
          content: '';
          position: absolute;
          inset: 0;
          background-image: 
            linear-gradient(rgba(255, 255, 255, 0.015) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255, 255, 255, 0.015) 1px, transparent 1px);
          background-size: 40px 40px;
          pointer-events: none;
          z-index: 2;
        }

        @keyframes float {
          0%, 100% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(40px, -40px) scale(1.1); }
        }

        @keyframes glowPulse {
          0%, 100% { opacity: 0.2; transform: scale(1); }
          50% { opacity: 0.5; transform: scale(1.15); }
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        /* Card Container (Glassmorphic) */
        .login-container {
          background: rgba(10, 11, 18, 0.7);
          border: 1px solid rgba(255, 255, 255, 0.06);
          border-radius: 28px;
          box-shadow: 
            0 20px 50px rgba(0, 0, 0, 0.5),
            0 0 100px rgba(var(--login-accent-rgb), 0.03),
            inset 0 1px 1px rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(30px) saturate(190%);
          padding: 56px 48px;
          width: 100%;
          max-width: 460px;
          position: relative;
          z-index: 10;
          transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
        }

        .login-container:hover {
          border-color: rgba(255, 255, 255, 0.1);
          box-shadow: 
            0 30px 60px rgba(0, 0, 0, 0.6),
            0 0 120px rgba(var(--login-accent-rgb), 0.06),
            inset 0 1px 1px rgba(255, 255, 255, 0.15);
        }

        .login-header {
          text-align: center;
          margin-bottom: 40px;
        }

        .login-logo {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 12px;
          height: 60px;
        }

        .logo-img {
          max-width: 220px;
          width: 100%;
          height: auto;
          object-fit: contain;
          filter: drop-shadow(0 8px 16px rgba(var(--login-accent-rgb), 0.2));
          transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
        }

        .logo-img:hover {
          transform: scale(1.04);
        }

        .login-brand-name {
          font-size: 28px;
          font-weight: 800;
          color: #ffffff;
          letter-spacing: -0.5px;
        }

        .login-subtitle {
          color: #9ca3af;
          font-size: 14px;
          font-weight: 400;
          letter-spacing: 0.5px;
          margin-top: 14px;
        }

        .login-form {
          display: flex;
          flex-direction: column;
          gap: 24px;
        }

        /* Form Inputs */
        .form-group {
          display: flex;
          flex-direction: column;
        }

        .form-label {
          font-size: 13px;
          font-weight: 600;
          color: #d1d5db;
          margin-bottom: 8px;
          letter-spacing: 0.3px;
        }

        .input-wrapper {
          position: relative;
        }

        .input-icon {
          position: absolute;
          left: 16px;
          top: 50%;
          transform: translateY(-50%);
          width: 18px;
          height: 18px;
          color: #9ca3af;
          transition: color 0.3s ease;
          pointer-events: none;
        }

        .input-wrapper .input {
          width: 100%;
          padding-left: 48px;
          padding-right: 16px;
          height: 52px;
          font-size: 14px;
          border-radius: 14px;
          background: rgba(17, 24, 39, 0.6);
          border: 1px solid rgba(255, 255, 255, 0.08);
          color: #ffffff;
          font-family: inherit;
          transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
          box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.2);
        }

        .input-wrapper .input::placeholder {
          color: #6b7280;
        }

        .input-wrapper .input:hover {
          border-color: rgba(255, 255, 255, 0.15);
          background: rgba(17, 24, 39, 0.8);
        }

        .input-wrapper .input:focus {
          outline: none;
          border-color: var(--login-accent-light);
          background: rgba(17, 24, 39, 0.9);
          box-shadow: 
            0 0 0 4px rgba(var(--login-accent-light-rgb), 0.15),
            inset 0 1px 2px rgba(0, 0, 0, 0.2);
        }

        .input-wrapper .input:focus + .input-icon {
          color: var(--login-accent-light);
        }

        /* Error Banner */
        .login-error {
          display: flex;
          align-items: center;
          gap: 12px;
          padding: 14px 18px;
          background: rgba(239, 68, 68, 0.08);
          border: 1px solid rgba(239, 68, 68, 0.2);
          border-radius: 14px;
          color: #fca5a5;
          font-size: 13px;
          font-weight: 500;
        }

        .login-error svg {
          width: 18px;
          height: 18px;
          flex-shrink: 0;
          color: #f87171;
        }

        /* Primary Button */
        .btn-lg {
          height: 52px;
          font-size: 15px;
          border-radius: 14px;
          font-weight: 600;
          background: linear-gradient(135deg, var(--login-accent) 0%, var(--login-accent-dark) 100%);
          color: #ffffff;
          border: none;
          cursor: pointer;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: inherit;
          transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
          box-shadow: 
            0 4px 20px rgba(var(--login-accent-rgb), 0.25),
            inset 0 1px 0 rgba(255, 255, 255, 0.2);
        }

        .btn-lg:hover:not(:disabled) {
          transform: translateY(-2px);
          background: linear-gradient(135deg, var(--login-accent-light) 0%, var(--login-accent) 100%);
          box-shadow: 
            0 8px 24px rgba(var(--login-accent-rgb), 0.4),
            inset 0 1px 0 rgba(255, 255, 255, 0.3);
        }

        .btn-lg:active {
          transform: translateY(0);
        }

        .btn-lg:disabled {
          opacity: 0.5;
          cursor: not-allowed;
          transform: none;
          box-shadow: none;
        }

        .loading-spinner {
          width: 22px;
          height: 22px;
          border: 3px solid rgba(255, 255, 255, 0.2);
          border-top-color: #ffffff;
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
        }

        /* Footer */
        .login-footer {
          margin-top: 32px;
          padding-top: 24px;
          border-top: 1px solid rgba(255, 255, 255, 0.05);
          text-align: center;
        }

        .register-link {
          display: inline-block;
          color: var(--login-accent-lighter);
          font-size: 14px;
          font-weight: 500;
          text-decoration: none;
          padding: 8px 16px;
          border-radius: 10px;
          transition: all 0.3s ease;
        }

        .register-link:hover {
          background: rgba(var(--login-accent-lighter-rgb), 0.06);
          color: var(--login-accent-lightest);
        }

        /* Branch Select Screen */
        .branch-list {
          display: flex;
          flex-direction: column;
          gap: 14px;
        }

        .branch-item {
          display: flex;
          align-items: center;
          gap: 16px;
          padding: 18px;
          background: rgba(17, 24, 39, 0.4);
          border: 1px solid rgba(255, 255, 255, 0.06);
          border-radius: 16px;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
          text-align: left;
          width: 100%;
        }

        .branch-item:hover {
          border-color: rgba(var(--login-accent-light-rgb), 0.3);
          background: rgba(var(--login-accent-light-rgb), 0.06);
          transform: translateY(-2px);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
        }

        .branch-icon {
          width: 44px;
          height: 44px;
          background: rgba(var(--login-accent-rgb), 0.1);
          border: 1px solid rgba(var(--login-accent-rgb), 0.2);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--login-accent-lighter);
          flex-shrink: 0;
        }

        .branch-icon svg {
          width: 22px;
          height: 22px;
        }

        .branch-info {
          flex: 1;
        }

        .branch-name {
          font-weight: 600;
          color: #ffffff;
          font-size: 15px;
        }

        .branch-industry {
          font-size: 12px;
          color: #9ca3af;
          margin-top: 3px;
        }

        @media (max-width: 500px) {
          .login-container {
            margin: 20px;
            padding: 40px 24px;
          }
        }
      `}</style>
    </div>
  );
}

export default Login;
